import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useSetAtom } from 'jotai';
import { Paper, Tabs, Tab, List } from '@mui/material';
import useAPI from '../../../../api';
import TemplateCard from './TemplateCard';
import NewElementBtn from './NewElementBtn';
import { openSnackbarAdviseAtom } from '../../../../Atoms';
import getErrorMessage from '../../../../Helpers/Errors/getErrorMessage';
import encodeBase64 from '../../../../Helpers/encode';

const LeftBar = function LeftBar({
  handleSelectTemplate = () => {},
  editorType = '',
  msgType = 'SMS',
  onChangeMsgType = () => {},
  handleCreateTemplate = () => {},
  handleEditTemplateList = () => {},
  handleSaveTemplate = () => {},
  templates = [],
}) {
  const intl = useIntl();
  const API = useAPI();
  const showSnackbar = useSetAtom(openSnackbarAdviseAtom);

  const handleEditLinkedOutcomes = (templateObj) => {
    const { id: templateId, outcomes, isNew } = templateObj;
    if (!isNew)
      API.linkOutcomesToTemplate(
        templateId,
        outcomes.map(({ outcomeId }) => outcomeId),
        { silent: true },
        () => {
          handleEditTemplateList(templateObj);
        },
        (err) => {
          showSnackbar({
            severity: 'error',
            message: `${intl.messages.ERROR_UPDATING_OUTCOMES} ${getErrorMessage(err) || ''}`,
          });
        }
      );
    else handleEditTemplateList(templateObj);
  };
  const handleDeleteTemplate = (templateId) => {
    const apiCall =
      editorType === 'TEMPLATES' ? API.deleteTemplate : API.deleteLandingPage;

    apiCall(
      templateId,
      { silent: true },
      () => {
        handleEditTemplateList({ id: templateId }, true);
      },
      (err) => {
        showSnackbar({
          severity: 'error',
          message: `${intl.messages.ERROR_DELETING} ${getErrorMessage(err) || ''}`,
        });
      }
    );
  };

  const isLandingPage = editorType !== 'TEMPLATES';
  const withSubject = !isLandingPage && msgType === 'EMAIL';

  const handleRenameTemplate = (template, { name, title }) =>
    handleSaveTemplate(
      {
        ...template,
        ...(isLandingPage
          ? { body: encodeBase64(JSON.stringify(template?.body)) }
          : {
              content: encodeBase64(template?.content || ''),
              ...(template?.structure
                ? {
                    structure: encodeBase64(JSON.stringify(template.structure)),
                  }
                : {}),
              ...(withSubject ? { title } : {}),
            }),
        name,
      },
      isLandingPage ? 'LANDING' : editorType
    );
  return (
    <Paper
      square
      elevation={2}
      sx={{
        height: '100%',
        width: '20%',
        display: 'flex',
        flexDirection: 'column',
        flexShrink: 0,
      }}
    >
      {!isLandingPage && (
        <Tabs variant="fullWidth" value={msgType} onChange={onChangeMsgType}>
          <Tab value="SMS" label={intl.messages.SMS} />
          <Tab value="EMAIL" label={intl.messages.EMAIL} />
        </Tabs>
      )}
      <div style={{ flexGrow: 1, overflow: 'auto', padding: '16px' }}>
        <List>
          <NewElementBtn
            text={intl.messages.NEW_TEMPLATE}
            handleAddNew={handleCreateTemplate}
            withSubject={withSubject}
            open
            paper
          />
        </List>
        {templates.map((t) => (
          <TemplateCard
            key={t?.id}
            name={t?.name}
            title={t?.title}
            withSubject={withSubject}
            hideOutcomes={isLandingPage}
            templateOutcomes={t?.outcomes}
            onClick={() => handleSelectTemplate(t?.id)}
            handleEditTemplate={(editedObj) =>
              handleEditLinkedOutcomes({ ...t, ...editedObj })
            }
            handleDeleteTemplate={() => handleDeleteTemplate(t?.id)}
            handleRenameTemplate={(values) => handleRenameTemplate(t, values)}
          />
        ))}
      </div>
    </Paper>
  );
};

LeftBar.propTypes = {
  handleSelectTemplate: PropTypes.func,
  editorType: PropTypes.string,
  msgType: PropTypes.string,
  onChangeMsgType: PropTypes.func,
  handleEditTemplateList: PropTypes.func,
  handleCreateTemplate: PropTypes.func,
  handleSaveTemplate: PropTypes.func,
  templates: PropTypes.string,
};

export default LeftBar;
